<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex justify-space-between align-center">
                            <h3>ดูรายละเอียดล๊อตเข้า</h3>
                            <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/alllot')">
                                ย้อนกลับ
                            </v-btn>
                        </div>
                        <div class="grid_lot_detail_in_list mt-2">
                            <div class="grid_lot_detail_in_list">
                                <div>รหัสล๊อตเข้า</div>
                                <div>{{ lot_detail.lot_code }}</div>
                                <div>วันที่</div>
                                <div>{{ lot_detail.dateTime }}</div>
                            </div>

                            <div class="grid_lot_detail_in_list">
                                <div>รหัสใบสั่งซื้ออ้างอิง</div>
                                <div>{{ lot_detail.refer }}</div>
                                <div>ผู้ตรวจสอบของเข้า</div>
                                <div>{{ lot_detail.user_name }}</div>
                            </div>
                        </div>
                        <v-tabs grow>
                            <v-tab @click="page(source_detail.id)" v-for="(source_detail,index) in source_list" :key="index">{{ source_detail.source_name }}</v-tab>
                        </v-tabs>
                        <div class="mt-2">
                            <div v-for="(detail,index) in data" :key="index">
                                <v-simple-table v-if="page_id == detail.id">
                                    <thead>
                                        <tr>
                                            <th class="text-center border_header_lot_detail_in_list">
                                                #
                                            </th>
                                            <th class="text-center border_header_lot_detail_in_list">
                                                วัตถุดิบ
                                            </th>
                                            <th class="text-center border_header_lot_detail_in_list">
                                                จำนวน
                                            </th>
                                            <th class="text-center border_header_lot_detail_in_list">
                                                หน่วยนับ
                                            </th>
                                            <th class="text-center border_header_lot_detail_in_list">
                                                ราคาต่อหน่วย
                                            </th>
                                            <th class="text-center border_header_lot_detail_in_list">
                                                สรุปรายการ
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(type_detail,index_type) in detail.typeList" :key="index_type">
                                        <tr>
                                            <td colspan="6" class="primary white--text">
                                                <div>
                                                    {{ type_detail.type_name }}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-for="(mat_detail,index_mat_detail) in type_detail.detailList" :key="index_mat_detail">
                                            <td class="text-center border_header_lot_detail_in_list">{{ index_mat_detail + 1 }}</td>
                                            <td class="text-center border_header_lot_detail_in_list">{{ mat_detail.mat_name }}</td>
                                            <td class="text-center border_header_lot_detail_in_list">
                                                {{ currencyFormat(mat_detail.quantity) }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_in_list">
                                               {{ mat_detail.unit_type == 1 ? mat_detail.unit_type_name : mat_detail.unit_type == 2 ? mat_detail.unit_other_name : '' }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_in_list">
                                                {{ mat_detail.lot_details_price }}
                                            </td>
                                            <td class="text-center border_header_lot_detail_in_list">
                                                {{ mat_detail.total }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center border_header_lot_detail_in_list" colspan="5">
                                                มูลค่ารวม
                                            </td>
                                            <td class="text-center border_header_lot_detail_in_list">
                                                {{ currencyFormat(type_detail.detailList.reduce((sum,number) => { return sum + parseFloat(number.total) }, 0)) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</div>
</template>

<script>
import inoutstockall from '@/api/stock/stocklist/inoutstockall.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            lot_detail: null,
            page_id: null,
            source_list: [],
            data: [],
        }
    },
    methods: {
        currencyFormat,
        async lotInDetail() {
            this.loading_page = true
            inoutstockall.lotInDetail(this.$store.state.lotDetailInId).then((response) => {
                if (response.data.successful === true) {
                    this.lot_detail = response.data.lot
                    response.data.sources.forEach((detail, index_source) => {
                        this.source_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                        if (index_source == 0) {
                            this.page_id = detail.id
                        }
                    })
                    this.data = response.data.sources
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page(id) {
            this.page_id = id
        },
    },
    mounted() {
        this.lotInDetail()
    },
}
</script>

<style scoped>
.grid_lot_detail_in_list {
    display: grid;
    grid-template-columns: auto auto;
}

.border_header_lot_detail_in_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
